var r,e;function o(){return e?r:(e=1,r=function(r){return"object"==typeof r&&!0===r.isAxiosError})}export{o as __require};
